<template>
    <v-menu offset-y nudge-bottom="10" left transition="slide-y-transition" content-class="students-actions-menu"
        :close-on-content-click="true">
        <template v-slot:activator="{ on, attrs, value }">
            <v-btn v-on="on" v-bind="attrs" fab depressed height="40" width="40" class="students-fab mr-3"
                :class="{ 'students-fab--open': value }">
                <v-icon size="20" color="#0C0E12">{{ value ? 'mdi-close' : 'mdi-plus' }}</v-icon>
            </v-btn>
        </template>
        <v-list class="py-1 students-actions-list" color="surface">
            <v-list-item v-for="(item, i) in items" :key="i" @click="onAction(item.event)"
                class="students-action-item">
                <v-list-item-icon class="my-0 mr-3 align-self-center">
                    <span class="action-icon-box">
                        <v-icon size="15">{{ item.icon }}</v-icon>
                    </span>
                </v-list-item-icon>
                <v-list-item-title class="action-label">{{ item.label }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { EventBus } from '@/utils/EventBus'

export default {
    name: 'CompanyAdminActions',
    computed: {
        items(vm = this) {
            return [
                { label: vm.$t('tooltips.add_student'), icon: 'mdi-account-plus-outline', event: 'invite' },
                { label: vm.$t('tooltips.add_coach'), icon: 'mdi-account-multiple-plus-outline', event: 'invite_coach' },
                { label: vm.$t('tooltips.selection_multiple'), icon: 'mdi-checkbox-multiple-marked-outline', event: 'selection' },
                { label: vm.$t('coach.pending_invitations'), icon: 'mdi-email-outline', event: 'invitations' },
                { label: vm.$t('company.pending_coach_invitations'), icon: 'mdi-email-multiple-outline', event: 'coach_invitations' },
            ]
        }
    },
    methods: {
        onAction(event) {
            EventBus.$emit(`admin:${event}`)
        }
    }
}
</script>

<style scoped>
.students-actions-list {
    min-width: 210px;
}

.students-fab {
    background: var(--brand-gradient) !important;
    box-shadow: 0 4px 16px rgba(204, 255, 51, 0.3) !important;
    transition: transform 0.15s, box-shadow 0.15s;
}

.students-fab:hover {
    transform: scale(1.08);
    box-shadow: 0 6px 20px rgba(204, 255, 51, 0.4) !important;
}

.action-icon-box {
    width: 28px;
    height: 28px;
    border-radius: 7px;
    background: linear-gradient(135deg, rgba(204, 255, 51, 0.15), rgba(51, 153, 153, 0.15));
    display: flex;
    align-items: center;
    justify-content: center;
}

.action-icon-box .v-icon {
    color: var(--v-primary-base);
}

.theme--light .action-icon-box {
    background: rgba(51, 153, 153, 0.12);
}

.theme--light .action-icon-box .v-icon {
    color: var(--v-accent-base);
}

.action-label {
    font-size: 13px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    color: var(--v-txtPrimary-base);
}
</style>
